//-----------------------------|| LIST ||---------------------------------------------------------------
export const SET_FORM_FIELDS_LIST = 'SET_FORM_FIELDS_LIST';
export const CLEAR_FORM_FIELDS_LIST = 'CLEAR_FORM_FIELDS_LIST';
export const FORM_FIELDS_LIST_PENDING = 'FORM_FIELDS_LIST_PENDING';
export const FORM_FIELDS_LIST_ERROR = 'FORM_FIELDS_LIST_ERROR';
export const FORM_FIELDS_LIST_ERROR_CLEAR = 'FORM_FIELDS_LIST_ERROR_CLEAR';

//-----------------------------|| UPDATE ||---------------------------------------------------------------
export const SET_SELECTED_FORM_FIELD_INDEX = 'SET_SELECTED_FORM_FIELD_INDEX';
export const FORM_FIELDS_UPDATE_PENDING = 'FORM_FIELDS_UPDATE_PENDING';
export const FORM_FIELDS_UPDATE_ERROR = 'FORM_FIELDS_UPDATE_ERROR';
export const FORM_FIELDS_UPDATE_ERROR_CLEAR = 'FORM_FIELDS_UPDATE_ERROR_CLEAR';

//-----------------------------|| DELETE ||---------------------------------------------------------------
export const FIELD_DELETE_CONFIRMATION_OPEN = 'FIELD_DELETE_CONFIRMATION_OPEN';
export const FIELD_DELETE_CONFIRMATION_CLOSE = 'FIELD_DELETE_CONFIRMATION_CLOSE';
export const FORM_FIELD_DELETE_PENDING = 'FORM_FIELD_DELETE_PENDING';
export const FORM_FIELD_DELETE_ERROR = 'FORM_FIELD_DELETE_ERROR';
export const FORM_FIELD_DELETE_ERROR_CLEAR = 'FORM_FIELD_DELETE_ERROR_CLEAR';

//-----------------------------|| FORMULA CREATE DIALOG ||---------------------------------------------------------------
export const FORMULA_CREATE_DIALOG_OPEN = 'FORMULA_CREATE_DIALOG_OPEN';
export const FORMULA_CREATE_DIALOG_CLOSE = 'FORMULA_CREATE_DIALOG_CLOSE';
export const SELECTED_FORMULA_FIELD_FOR_CREATE = 'SELECTED_FORMULA_FIELD_FOR_CREATE';

//-----------------------------|| FORMULA EDIT DIALOG ||---------------------------------------------------------------
export const FORMULA_EDIT_DIALOG_OPEN = 'FORMULA_EDIT_DIALOG_OPEN';
export const FORMULA_EDIT_DIALOG_CLOSE = 'FORMULA_EDIT_DIALOG_CLOSE';
export const SELECTED_FORMULA_FIELD_FOR_EDIT = 'SELECTED_FORMULA_FIELD_FOR_EDIT';
